import addDays from "date-fns/addDays";

export default function createNewSliderDates(centralDate, daysLimit) {
    const slides: Date[] = [];
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    // eslint-disable-next-line no-plusplus
    for (let i = daysLimit.min; i <= daysLimit.max; i++) {
        const dateToShow = addDays(new Date(centralDate), i);
        if (dateToShow.getTime() >= yesterday.getTime()) {
            slides.push(dateToShow);
        }
    }

    return slides
}